import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { TextWithImages } from '../TextWithImages';

const useLocalStyles = makeStyles(theme => ({
  root: {
    '& .MuiAccordion-root::before': {
      backgroundColor: 'transparent !important'
    }
  },
  accordion: {
    borderRadius: '10px',
    marginTop: '0.5em'
  }
}));

export const Licences = () => {
  const { t } = useTranslation('documentation');
  const localClasses = useLocalStyles();

  const accordionData = [
    {
      title: t('general.licenses.admin.title'),
      content: t('general.licenses.admin.content')
    },
    {
      title: t('general.licenses.collaborator.title'),
      content: t('general.licenses.collaborator.content')
    },
    {
      title: t('general.licenses.boughtLicences.title'),
      content: t('general.licenses.boughtLicences.content')
    },
    {
      title: t('general.licenses.twoLicencesTypes.title'),
      content: t('general.licenses.twoLicencesTypes.content')
    },
    {
      title: t('general.licenses.nominativeLicence.title'),
      content: t('general.licenses.nominativeLicence.content')
    }
  ];

  return (
    <div></div>
    /* 
    <TextWithImages
      src={'/images/views/documentation/general/Professional_Licenses.png'}
      alt={t('general.features.header')}
      wrapperClass={localClasses.root}
      reverse>
      <h3>{t('general.licenses.title')}</h3>
      {accordionData.map(({ title, content }, index) => (
        <Accordion key={index} className={localClasses.accordion}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h3
              style={{
                fontSize: '20px',
                color: '#54C278',
                fontWeight: '500'
              }}>
              {title}
            </h3>
          </AccordionSummary>
          <AccordionDetails>
            <p>{content}</p>
          </AccordionDetails>
        </Accordion>
      ))}
    </TextWithImages>
  );
  */
  );
};
